import { render, staticRenderFns } from "./personalAdd.vue?vue&type=template&id=745f729b&scoped=true"
import script from "./personalAdd.vue?vue&type=script&lang=js"
export * from "./personalAdd.vue?vue&type=script&lang=js"
import style0 from "./personalAdd.vue?vue&type=style&index=0&id=745f729b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f729b",
  null
  
)

export default component.exports